import { useSelector } from "react-redux";

import { useMakesActions } from "store/MakesSlice";
import { makeAttributes } from "utils/makeUtils";

const useMakes = () => {
  const {
    createMake,
    loadMake,
    clearMake,
    patchMake,
    loadMakes,
    clearMakes,
    loadMoreMakes,
    deleteMake,
    updateMake,
  } = useMakesActions();

  const { make, makes, meta } = useSelector((state) => state.MakesSlice);

  const saveMake = ({ roles, templateId, makeThumb, shareThumb, renderMp4 }) => {
    const attrs = makeAttributes({ makeThumb, shareThumb, roles, templateId });
    attrs.renderMp4 = renderMp4;

    return createMake(attrs);
  };

  return {
    saveMake,
    loadMake,
    make,
    clearMake,
    patchMake,
    loadMakes,
    loadMoreMakes,
    clearMakes,
    makes,
    meta,
    deleteMake,
    updateMake,
  };
};

export default useMakes;
